import React from "react";
import { Body, Micro } from "@vds/typography";
import { ByodContainer } from "pages/ShoppingCart/components/CartPackage/styles";
import styled from "styled-components";
import { getImage } from "utils/imageUtils";
import { ellipsisShorten } from "utils/commonUtils";
import { useMediaQuery } from "react-responsive";

const StickyImageContainer = ({
    imageSet,
    selectContent,
    description,
    byod,
    ...props
}) => {
    const isMobile = useMediaQuery({
        query: "(max-width: 725px)",
      });
    return (
        <StickyLeftSection>
            {imageSet ? <StickyLeftSectionContent>
                <img
                    height={"30"}
                    width={"22"}
                    src={getImage(imageSet, 30, 22)}
                />
            </StickyLeftSectionContent>
                : byod ? <ByodContainer width={"22"} height={"30"}><ByodImg /></ByodContainer>
                    : <></>}
            <TitleContainer byod={byod}>
                <Micro>{selectContent}</Micro>
              {byod ? isMobile ? <Body size="large" bold>{ellipsisShorten(description,12)} (your own device)</Body> : <Body size="large" bold>{description} (your own device)</Body>  
              : isMobile ? <Body size="large" bold>{ellipsisShorten(description,34)}</Body>  : <Body size="large" bold>{description}</Body>}
            </TitleContainer>
        </StickyLeftSection>
    );
};
const StickyLeftSection = styled.div`
align-items:center;
display:flex;
`;
const TitleContainer=styled.div`
${({ byod }) => byod ?
`padding-left:10px !important;`
:`padding-left:0px !important;`}

`

const StickyLeftSectionContent = styled.div`
padding-right:8px;
`
export const ByodImg = styled.div`
  width: 30px;
  height: 100px;
  border-style: solid;
  border-radius: 9px;
  border-width: 2px;
  border-color: #A7A7A7;
`;
export default StickyImageContainer;
